import * as React from "react";
import { StepWizardNavChildProps, StepState } from "../WizardStepper.types";
import { WizardNavIndicator } from "./WizardNavIndicator";

export class WizardNavBar extends React.PureComponent<
  StepWizardNavChildProps,
  {}
> {
  constructor(props: any) {
    super(props);
  }

  public stepChanged = (stepId: number) => {
    this.props.goToStep(stepId);
  };

  private renderSteps = (stepState: StepState, index: number) => {
    const { currentStep, thankYouStep } = this.props;
    return (
      <WizardNavIndicator
        currentStep={currentStep + 1}
        thankYouStep={this.props.thankYouStep}
        isThankYouPage={this.props.thankYouStep === index + 1}
        key={stepState.stepId}
        onClick={this.stepChanged}
        isActive={currentStep === index}
        {...stepState}
      />
    );
  };

  public render(): JSX.Element {
    const { steps } = this.props;
    return (
      <div className="wizardstepperwrapper">
        <ol className="wizardstepper" aria-label="Var är jag i processen?">
          {steps.map(this.renderSteps)}
        </ol>
        <div className="wizardstepper__line"></div>
      </div>
    );
  }
}
